// AI-CONTEXT: See docs/features/agenda-role-colors.md

// Neutral marker for a persona whose role has no color, or whose role was deleted.
export const FALLBACK_ROLE_COLOR = '#c4c4c4'

const roleColorByPersona = (personas, userRoles) => {
    if (!Array.isArray(personas) || !Array.isArray(userRoles)) return {}

    const roleById = new Map(
        userRoles.filter((role) => role?.ID).map((role) => [role.ID, role])
    )

    return personas.reduce((map, persona) => {
        if (!persona?.ID || !persona?.UserRoleID) return map

        const role = roleById.get(persona.UserRoleID)
        map[persona.ID] = {
            roleId: persona.UserRoleID,
            roleName: role?.Name || '',
            color: role?.Color || FALLBACK_ROLE_COLOR,
        }
        return map
    }, {})
}

export default roleColorByPersona
